import { Checkbox } from "@/components/ui/checkbox-alt";
import { Input } from "@/components/ui/input";
import { cn } from "@/lib/utils";
import React, { FC, useState } from "react";

interface Props {
  setCurrentStep: React.Dispatch<React.SetStateAction<number>>;
  name: string;
  setName: React.Dispatch<React.SetStateAction<string>>;
  ruc: string;
  setRuc: React.Dispatch<React.SetStateAction<string>>;
  tradeName: string;
  setTradeName: React.Dispatch<React.SetStateAction<string>>;
  address: string;
  setAddress: React.Dispatch<React.SetStateAction<string>>;
  website: string;
  setWebsite: React.Dispatch<React.SetStateAction<string>>;
}

const CompanyData: FC<Props> = ({
  setCurrentStep,
  address,
  name,
  ruc,
  setAddress,
  setName,
  setRuc,
  setTradeName,
  setWebsite,
  tradeName,
  website,
}) => {
  const [formError, setFormError] = useState<any>({});

  const regexLetras = /[a-zA-Z]/;
  const regexHttps = /^https:\/\//;

  const handleNextStep = () => {
    let errors: any = {};
    if (!name) {
      errors.name = true;
      errors.nameMessage = "La razón social es obligatoria";
    } else if (!ruc) {
      errors.ruc = true;
      errors.rucMessage = "El RUC es obligatorio";
    } else if (ruc?.length < 11) {
      errors.ruc = true;
      errors.rucMessage = "El RUC debe tener 11 dígitos";
    } else if (regexLetras.test(ruc)) {
      errors.ruc = true;
      errors.rucMessage = "Ingresa un RUC válido";
    } else if (!tradeName) {
      errors.tradeName = true;
      errors.tradeNameMessage = "El nombre comercial es obligatorio";
    } else if (!address) {
      errors.address = true;
      errors.addressMessage = "La dirección es obligatoria";
    } else if (website && !regexHttps.test(website)) {
      errors.website = true;
      errors.websiteMessage = "Ingresa un sitio web seguro";
    } else {
      setCurrentStep(1);
    }
    setFormError(errors);
  };

  return (
    <div className="mt-8 flex flex-col items-center justify-center">
      <div className="flex w-full max-w-[450px] flex-col gap-3">
        <p className="mt-3 text-sm font-medium text-[#4F5D6D]">Razón social*</p>
        <Input
          value={name}
          placeholder="Ingresa la razón social"
          className={`rounded-2xl border-[#A0ACBA] py-6 ${
            formError.name ? "border-red-500" : ""
          }`}
          onChange={(event) => {
            setFormError({
              ...formError,
              name: false,
            });
            setName(event.target.value);
          }}
        />
        {formError.name && formError.nameMessage && (
          <p className="mt-1 text-xs text-red-500">{formError?.nameMessage}</p>
        )}
        <p className="mt-3 text-sm font-medium text-[#4F5D6D]">RUC*</p>
        <Input
          disabled
          value={ruc}
          maxLength={11}
          placeholder="Ingresa el RUC"
          className={`rounded-2xl border-[#A0ACBA] py-6 ${
            formError.ruc ? "border-red-500" : ""
          }`}
          onChange={(event) => {
            setFormError({
              ...formError,
              ruc: false,
            });
            setRuc(event.target.value);
          }}
        />
        {formError.ruc && formError.rucMessage && (
          <p className="mt-1 text-xs text-red-500">{formError?.rucMessage}</p>
        )}
        <p className="mt-3 text-sm font-medium text-[#4F5D6D]">
          Nombre comercial*
        </p>
        <Input
          value={tradeName}
          placeholder="Ingresa el nombre comercial"
          className={`rounded-2xl border-[#A0ACBA] py-6 ${
            formError.tradeName ? "border-red-500" : ""
          }`}
          onChange={(event) => {
            setFormError({
              ...formError,
              tradeName: false,
            });
            setTradeName(event.target.value);
          }}
        />
        {formError.tradeName && formError.tradeNameMessage && (
          <p className="mt-1 text-xs text-red-500">
            {formError?.tradeNameMessage}
          </p>
        )}
        <p className="mt-3 text-sm font-medium text-[#4F5D6D]">Dirección*</p>
        <Input
          value={address}
          placeholder="Ingresa la dirección"
          className={`rounded-2xl border-[#A0ACBA] py-6 ${
            formError.address ? "border-red-500" : ""
          }`}
          onChange={(event) => {
            setFormError({
              ...formError,
              address: false,
            });
            setAddress(event.target.value);
          }}
        />
        {formError.address && formError.addressMessage && (
          <p className="mt-1 text-xs text-red-500">
            {formError?.addressMessage}
          </p>
        )}
        <p className="mt-3 text-sm font-medium text-[#4F5D6D]">Sitio web</p>
        <Input
          value={website}
          placeholder="Añada su sitio web"
          className={`rounded-2xl border-[#A0ACBA] py-6 ${
            formError.website ? "border-red-500" : ""
          }`}
          onChange={(event) => {
            setFormError({
              ...formError,
              website: false,
            });
            setWebsite(event.target.value);
          }}
        />
        {formError.website && formError.websiteMessage && (
          <p className="mt-1 text-xs text-red-500">
            {formError?.websiteMessage}
          </p>
        )}
      </div>
      <div className="mt-6 flex items-center gap-2">
        <Checkbox />
        <p className="text-sm">
          Acepto la
          <span className="font-semibold text-[#615CB7]">
            {" "}
            Política de Privacidad de Datos{" "}
          </span>
          de EGS
        </p>
      </div>
      <div className="mt-4 flex items-center justify-center py-3">
        <div
          className={cn(
            "flex cursor-pointer select-none items-center gap-3 rounded-2xl bg-[#262452] px-20 py-3 text-center text-sm font-medium text-white",
          )}
          onClick={handleNextStep}
        >
          Siguiente
        </div>
      </div>
    </div>
  );
};

export default CompanyData;
